

export const DayOfWeekMap = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6
} //matches enum built in c#


export const DayOfWeekArray = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]; //this order matches the enum built into c#

export const ParametersLabelToDisplayText = {
  earliestStart: "Earliest Start Time",
  latestStart: "Latest Start Time",
  excludedStations: "Excluded Stations"
}
